import _extends from'@babel/runtime/helpers/extends';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import React,{useMemo}from'react';import PropTypes from'prop-types';import {useIntl,FormattedMessage}from'react-intl';import CIAMLink from'../CIAMLink/CIAMLink.js';import Checkbox from'../Checkbox/Checkbox.js';import ExpandableParagraph from'../ExpandableParagraph/ExpandableParagraph.js';import FormattedRichMessage from'../FormattedRichMessage/FormattedRichMessage.js';import {validUsername,validIsRequired}from'../../utils/validation.js';import FormTextInput from'../FormTextInput/FormTextInput.js';import noop from'../../utils/noop.js';var USERNAME_VARIANTS = {
  CREATE: 'create',
  MODIFIY: 'modify',
  PROMPT: 'prompt',
  LOGIN: 'login'
};
var UsernameInput = function UsernameInput(_ref) {
  var id = _ref.id,
    value = _ref.value,
    onChange = _ref.onChange,
    variant = _ref.variant,
    rememberUsername = _ref.rememberUsername,
    onRememberUsernameChange = _ref.onRememberUsernameChange,
    labelId = _ref.labelId,
    isEmbedded = _ref.isEmbedded,
    hideForgotUsername = _ref.hideForgotUsername,
    rest = _objectWithoutProperties(_ref, ["id", "value", "onChange", "variant", "rememberUsername", "onRememberUsernameChange", "labelId", "isEmbedded", "hideForgotUsername"]);
  var intl = useIntl();
  var combinedValidationList = useMemo(function () {
    return ['shared.username.checklist.minMax', 'shared.username.checklist.noSpace', 'shared.username.checklist.noDotAsFirstLast', 'shared.username.checklist.hasNoInvalidCharacters'];
  }, []);
  var defaultHidden = useMemo(function () {
    return ['shared.username.checklist.hasNoInvalidCharacters'];
  }, []);
  var renderVariant = function renderVariant() {
    if (isEmbedded && variant === USERNAME_VARIANTS.LOGIN) {
      return /*#__PURE__*/React.createElement(CIAMLink, {
        to: "/forgotusername"
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "shared.username.forgotUsername"
      }));
    }
    if (variant === USERNAME_VARIANTS.LOGIN) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checkbox, {
        id: "remember-me",
        label: intl.formatMessage({
          id: 'shared.username.rememberUsername'
        }),
        checked: rememberUsername,
        onChange: onRememberUsernameChange,
        customStyle: {
          checkboxStyle: {
            margin: '10px 10px 10px 0'
          }
        }
      }), /*#__PURE__*/React.createElement(CIAMLink, {
        to: "/forgotusername"
      }, intl.formatMessage({
        id: 'shared.username.forgotUsername'
      })));
    }
    if (variant === USERNAME_VARIANTS.PROMPT && !hideForgotUsername) {
      return /*#__PURE__*/React.createElement(CIAMLink, {
        to: "/forgotusername"
      }, intl.formatMessage({
        id: 'shared.username.forgotUsername'
      }));
    }
    if (variant === USERNAME_VARIANTS.CREATE) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ExpandableParagraph, {
        id: "usernameEmailShow",
        collapsedContent: /*#__PURE__*/React.createElement(FormattedRichMessage, {
          id: "shared.username.same.collapsed"
        }),
        expandedContent: /*#__PURE__*/React.createElement(FormattedRichMessage, {
          id: "shared.username.same.expanded"
        }),
        showMoreButtonAriaLabel: intl.formatMessage({
          id: 'shared.username.same.showMoreAriaLabel'
        }),
        showLessButtonAriaLabel: intl.formatMessage({
          id: 'shared.username.same.showLessAriaLabel'
        })
      }));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormTextInput, _extends({
    id: id,
    label: intl.formatMessage({
      id: labelId
    }),
    value: value,
    onChange: onChange,
    autoComplete: "username",
    inputMode: "email",
    validations: variant === USERNAME_VARIANTS.CREATE ? validUsername : validIsRequired,
    validationsCombinedLabel: combinedValidationList === null || combinedValidationList === void 0 ? void 0 : combinedValidationList.map(function (item) {
      return intl.formatMessage({
        id: item
      });
    }),
    defaultHidden: defaultHidden === null || defaultHidden === void 0 ? void 0 : defaultHidden.map(function (item) {
      return intl.formatMessage({
        id: item
      });
    }),
    isCheckList: variant === USERNAME_VARIANTS.CREATE
  }, rest)), renderVariant());
};
process.env.NODE_ENV !== "production" ? UsernameInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  rememberUsername: PropTypes.bool,
  onRememberUsernameChange: PropTypes.func,
  variant: PropTypes.oneOf(Object.values(USERNAME_VARIANTS)),
  labelId: PropTypes.string,
  isEmbedded: PropTypes.bool,
  hideForgotUsername: PropTypes.bool
} : void 0;
UsernameInput.defaultProps = {
  id: 'username',
  variant: USERNAME_VARIANTS.PROMPT,
  rememberUsername: false,
  onRememberUsernameChange: noop,
  labelId: 'shared.username',
  isEmbedded: false,
  hideForgotUsername: false
};
var UsernameInput$1 = UsernameInput;export{USERNAME_VARIANTS,UsernameInput$1 as default};